import {
    SET_USER_DATA,
    CLEAR_USER,
    SET_BEARER_TOKEN,
    SET_USER_MATCHES,
    SET_FAVORITE_MATCH,
    SET_MATCH_REQUEST_STATE,
    SET_SINGLE_MATCH,
    SET_SINGLE_MATCH_STATE,
    SET_USER_INTERESTS,
    SET_INTEREST_REQUEST_STATE,
    SET_USER_UPDATE_STATE,
    SET_PROPERTIES_UPDATE_STATE,
    SET_EDITING_PROPERTIES,
    SET_EDITING_PROPERTIES_STATE,
    SET_FAVORITE_REQUEST_STATE,
    SET_PASSWORD_CHANGE_STATE,
    SET_PASSWORD_CHANGE_MESSAGE
} from "../actions/userActions";
import {
    requestState
} from "../actions/utils";
import {
    SET_PREVIEW_MATCHES_STATE,
    SET_PREVIEW_MATCHES
} from "../actions/matchmakingPreview";

const initialState = {
    data: {},
    bearerToken: undefined,
    matches: [],
    matchState: requestState.none,
    favoriteState: requestState.none,
    singleMatch: null,
    singleMatchState: requestState.none,
    interests: [],
    interestState: requestState.none,
    updateState: requestState.none,
    editingProperties: undefined,
    editingPropertiesState: requestState.none,
    propertiesUpdateState: requestState.none,
    passwordChangeState: requestState.none,
    passwordChangeMessage: "",
    previewMatches: [],
    previewMatchesState: requestState.none,

}

export default function userReducer(state = initialState, action) {
    switch (action.type) {

        case SET_USER_DATA:
            return {
                ...state,
                data: action.data
            }
        case SET_BEARER_TOKEN:
            return {
                ...state,
                bearerToken: action.token
            }
        case SET_PREVIEW_MATCHES_STATE:
            return {
                ...state,
                previewMatchesState: action.state
            }
        case SET_PREVIEW_MATCHES:
            return {
                ...state,
                previewMatches: action.matches
            }
        case SET_USER_MATCHES:
            return {
                ...state,
                matches: action.matches
            }
        case SET_MATCH_REQUEST_STATE:
            return {
                ...state,
                matchState: action.state
            }
        case SET_SINGLE_MATCH:
            return {
                ...state,
                singleMatch: action.match
            }
        case SET_SINGLE_MATCH_STATE:
            return {
                ...state,
                singleMatchState: action.state
            }
        case SET_FAVORITE_MATCH:
            var favPropertyIndex = -1;
            for (let i = 0; i < state.matches.length; i++) {
                if (state.matches[i].announcement.id === action.id) {
                    favPropertyIndex = i;
                    break;
                }
            }
            var interestedPropertyIndex = -1;
            for (let i = 0; i < state.interests.length; i++) {
                if (state.interests[i].id === action.id) {
                    interestedPropertyIndex = i;
                    break;
                }
            }
            return {
                ...state,
                matches: favPropertyIndex >= 0 ? [
                    ...state.matches.slice(0, favPropertyIndex),
                    {
                        ...state.matches[favPropertyIndex],
                        favorite: action.favorite
                    },
                    ...state.matches.slice(favPropertyIndex + 1)
                ] : state.matches,
                interests: interestedPropertyIndex >= 0 ? [
                    ...state.interests.slice(0, interestedPropertyIndex),
                    {
                        ...state.interests[interestedPropertyIndex],
                        favorite: action.favorite
                    },
                    ...state.interests.slice(interestedPropertyIndex + 1)
                ] : state.interests
            }
        case SET_FAVORITE_REQUEST_STATE:
            return {
                ...state,
                favoriteState: action.state
            }
        case SET_USER_INTERESTS:
            return {
                ...state,
                interests: action.interests
            }
        case SET_INTEREST_REQUEST_STATE:
            return {
                ...state,
                interestState: action.state
            }
        case SET_USER_UPDATE_STATE:
            return {
                ...state,
                updateState: action.state
            }
        case SET_EDITING_PROPERTIES:
            return {
                ...state,
                editingProperties: action.properties
            }
        case SET_EDITING_PROPERTIES_STATE:
            return {
                ...state,
                editingPropertiesState: action.state
            }
        case SET_PROPERTIES_UPDATE_STATE:
            return {
                ...state,
                propertiesUpdateState: action.state
            }
        case SET_PASSWORD_CHANGE_STATE:
            return {
                ...state,
                passwordChangeState: action.state
            }
        case SET_PASSWORD_CHANGE_MESSAGE:
            return {
                ...state,
                passwordChangeMessage: action.message
            }
        case CLEAR_USER:
            return {
                ...initialState
            }
        default:
            return state;
    }
}